import {HTMLInputTypeAttribute, JSX} from "react";

import Form from 'react-bootstrap/Form';

interface FormGroupProps {
    labelValue: string,
    inputType: HTMLInputTypeAttribute | "textarea",
    inputMaxLength?: number;
    inputName: string;
    inputValue: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    errors?: Array<string>;
    required: boolean;
}

export default function FormGroup({
                                      labelValue,
                                      inputType,
                                      inputMaxLength,
                                      inputValue,
                                      inputName,
                                      onChange,
                                      errors,
                                      required }: FormGroupProps): JSX.Element {
    return (
        <Form.Group className={"mb-3"}>
            <Form.Label className={""}><strong>{ labelValue }:</strong></Form.Label>
            {
                inputType === "textarea" ?
                    <textarea
                            className={"form-control"}
                            value={inputValue}
                            name={inputName}
                            onChange={onChange}
                            required={required}
                    /> :
                    (
                        <Form.Control
                            type={inputType}
                            maxLength={inputMaxLength}
                            name={inputName}
                            value={inputValue}
                            onChange={onChange}
                            required={required}
                        />
                    )
            }
            {
                errors && (
                    <div className={"p-2"}>
                        {
                            errors.map(
                                (error: string, indx: number) => <div className={"text-danger"} key={indx}>{ error }</div>
                            )
                        }
                    </div>
                )
            }
        </Form.Group>
    );
}